
import { Icons } from "components";
import { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";

import {COLORS} from "utils/colors"

import { useRef } from "react";

import { useAuth } from "utils/hooks";

import { sidebarConfig } from "routes";

/**
 * Sidebar navigation component that renders navigation sections and subsections
 * based on user authorization. Supports navigation and logout functionality.
 * @memberof module:components/sidebars
 * @component
 * @param {object} props - Component props (currently unused).
 * @returns {JSX.Element} Sidebar navigation JSX element.
 */
const Sidebar = (props) => {
  const navigate = useNavigate();
  const { onLogout, verifyAuthorization } = useAuth();

  const [activeKey, setActiveKey] = useState("");
  const [activeSection, setActiveSection] = useState(0);

  const location = useLocation();
  const prevPathRef = useRef(null);

  useEffect(() => {
    var initPath = location.pathname;

    setActiveKey(initPath);
    var activeSectionIndex = sidebarConfig.sections.find((el) =>
      el.subsections.find((el1) => el1.route === initPath)
    )?.title;
    setActiveSection(
      sidebarConfig.sections.findIndex((el) => el.title === activeSectionIndex)
    );
  }, [location.pathname]);

  const filteredSections = sidebarConfig.sections
    .map((section) => ({
      ...section,
      subsections: section.subsections.filter((subsection) =>
        verifyAuthorization(subsection.roles) && subsection.isEnabled
      ),
    }))
    .filter((section) => section.subsections.length > 0 );

  return (
    <Nav
      activeKey={activeKey}
      style={{
        marginTop: "0px",
        paddingTop: 10,
        height: "calc(100vh - 56px)",
        width: props.collapsed ? 60 : 250,
        flex: 1,
        display: "flex",
        display: "column",
        justifyContent: "space-between",
      }}
      variant="pills"
      className="d-none d-sm-flex flex-column sidebarNav sidebar justify-content-between"
    >
      <div style={{ overflowY: "auto", flex: 1 }}>
        <Nav.Item>
          {filteredSections.map((section, sectionIndex) => {
            return (
              <Nav.Item key={sectionIndex}>
                <Nav.Link
                  className={
                    activeSection === sectionIndex
                      ? "section_active"
                      : "section"
                  }
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                  }}
                >
                  {!props.collapsed && <strong>{section.title}</strong>}
                </Nav.Link>
                <Nav.Item>
                  {section.subsections.map((subsection, subsectionIndex) => {
                    return (
                      <Nav.Item key={sectionIndex + "-" + subsectionIndex}>
                        <Nav.Link
                          className={props.collapsed ? "subsection_collapsed":"subsection"}
                          eventKey={`${subsection.route}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            paddingLeft: 20,
                          }}
                          onClick={(e) => {
                            if (subsection.redirect) {
                              window.open(
                                subsection.redirect,
                                "_blank",
                                "noreferrer"
                              );
                              return;
                            }

                            setActiveSection(sectionIndex);
                            setActiveKey(`${subsection.route}`);
                            if (subsection.route) navigate(subsection.route);
                          }}
                        >
                          <Icons
                            name={subsection.icon}
                            width={20}
                            height={20}
                          />

                          {!props.collapsed && subsection.title}
                        </Nav.Link>
                      </Nav.Item>
                    );
                  })}
                </Nav.Item>
              </Nav.Item>
            );
          })}
        </Nav.Item>
      </div>
      <Nav.Item style={{ paddingBottom: 0 }}>
        <hr style={{ margin: 0 }} />
        <Nav.Link
          className="subsection_logout"
          eventKey={`logout`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            paddingLeft: 20,
            paddingBottom:20,
            color: "red",
          }}
          onClick={(e) => {
            onLogout();
          }}
        >
          <Icons
            name={"logout-icon"}
            color={"#bf1f27"}
            width={20}
            height={20}
          />

          {!props.collapsed && "Logout"}
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default Sidebar;
